<template>
    <transition
      :css="false"
      @before-enter="beforeEnter"
      @enter="enter"
    >
      <slot></slot>
    </transition>
</template>

<script>
import Velocity from 'velocity-animate'
export default {
  props: {
    delay: {
      type: Number,
      default: 100
    },
    duration: {
      type: Number,
      default: 1000
    },
    speed: {
      type: Number,
      default: 1.5
    }
  },
  methods: {
    beforeEnter (el) {
      el.style.opacity = 0
    },
    enter (el, done) {
      el.style.opacity = 0
      Velocity(el,
        {
          opacity: 1
        },
        {
          duration: this.duration / this.speed,
          delay: this.delay / this.speed,
          complete: done
        }
      )
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/transitions/OFadeTransition.vue